// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__0WDnB","disabled":"Switch_disabled__Rpfu5","slider":"Switch_slider__l+ZiK","sliderTransparent":"Switch_sliderTransparent__T7hxl"};